import React, { useEffect, useState } from 'react'
import { firestore } from '../../../../firebase'

function AddPlayerSquadSeasonListTemplate({player, teamId, season, squad, playerIsAdded}) {

    const AVATAR_URL = "https://firebasestorage.googleapis.com/v0/b/backend-footgrail.appspot.com/o/players%2Favatar-default.jpg?alt=media&token=06ae4bfc-6276-40aa-ad58-0968fea10f8e"
    const [isAddedToSquad, setIsAddedToSquad] = useState(playerIsAdded)

    const [playerSquad, setPlayerSquad] = useState()

    useEffect(() => {
        if (squad && player) {
            console.log("playerIsAdded: ", playerIsAdded)
            setPlayerSquad(player)
            setIsAddedToSquad(playerIsAdded)
        }
       
    }, [squad, player])

    async function addPlayerSquadHandler(player) {
        
        if (isAddedToSquad) {
            console.log("Added")
            return
        }

        try {
            const teamSquadRef = firestore.collection("teams").doc(teamId).collection("team-squads")
            const data = {
                player_image: player.player_image || AVATAR_URL,
                player_name: player.player_name,
                player_number: player.player_number || "99",
                player_parent_id: player.player_parent_id,
                position: player.position || "",
                season: season,
                team_id: teamId
            }
            console.log(data)
            teamSquadRef.add(data)
            console.log("ADDED")
        } catch (error) {
            console.log(error)
        }
    }

    function isPlayerAdded(playerId) {
        let isAdded = false;
        const playersFound = squad?.filter(
            (player) => player.player_parent_id === playerId
        );
        if (playersFound?.length > 0) {
            isAdded = true;
        }
        return isAdded;
    }

    if (!squad || !player) {
        return
    }



    return (
        <div className="col-4 col-lg-3 col-xl-2" onClick={() => addPlayerSquadHandler(player)} >
            <img src={playerSquad?.player_image} alt="" />
            <p><small>{playerSquad?.player_name} </small> {isAddedToSquad === true && <i className="fas fa-check text-success"></i>} </p>

            <p>Season: {playerSquad?.season}</p>
        </div>
    )
}
export default AddPlayerSquadSeasonListTemplate